import React, { useMemo } from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import { Toaster } from 'react-hot-toast'

import DefaultLayout from '@/components/layouts/Default'
import VerticalLayout from '@/components/layouts/Vertical'

import { authProtectedFlattenRoutes, publicRoutes } from './index'
import { useThemeContext } from '@/context'
import useUserPermission from '@/hooks/services/useUserPermission'
import { PreloaderFull } from '@/components/lib/molecules/Preloader'
import { PERMISSIONS } from '@/constants/permission'
import { MENU_ITEMS } from '@/constants'
interface IRoutesProps {}

const ThemeRoutes = (props: IRoutesProps) => {
  const { settings } = useThemeContext();

  const { userPermissions, isUserPermissionsLoading } = useUserPermission({ userId: settings.auth.userId })

  const filteredRoutes = useMemo(() => {
    const routes = authProtectedFlattenRoutes.map((route: any) => ({
      ...route,
      hasPermission: !!userPermissions?.[route.permission],
    }));
    if (userPermissions && !userPermissions[PERMISSIONS['Company Management']]) {
      const path = MENU_ITEMS.find((route: any) => userPermissions[route.permission])?.url || '/profile';
      routes[0] ={
        ...routes[0],
        hasPermission: true,
        element: <Navigate to={path} replace />
      };
    }
    return routes;
  }, [userPermissions])
  return (
    <React.Fragment>
      {(settings.auth.userId && isUserPermissionsLoading) && <PreloaderFull />}
      <Routes>
        <Route>
          {publicRoutes.map((route: any, idx: number) => (
            <Route
              path={route.path}
              element={<DefaultLayout {...props}>{route.element}</DefaultLayout>}
              key={idx}
            />
          ))}
        </Route>

        <Route>
          {filteredRoutes.map((route, idx) => route && (
            <Route
              path={route.path}
              element={
                !settings?.auth?.isAuthenticated ? (
                  <Navigate
                    to={{
                      pathname: '/login',
                      // search: 'next=' + route.path,
                    }}
                  />
                ) : (
                  <VerticalLayout {...props}>{route.hasPermission ? route.element : <div>Oops</div>}</VerticalLayout>
                )
              }
              key={idx}
            />
          ))}
        </Route>
        <Route path='*' element={<div>Oops</div>} />
      </Routes>
      <Toaster position="top-center" />
    </React.Fragment>
  )
}

export default ThemeRoutes
